import { background } from 'common/colors';

export default {
  root: {
    '&:hover:not($disabled)': {
      backgroundColor: background
    }
  }
};
